import { useState, useEffect } from 'react';

/**
 * Kthen faktorin e zoom-it për projektim:
 * - jashtë fullscreen → 1 (pa ndryshim)
 * - në fullscreen → shkallëzohet sipas gjerësisë së ekranit (deri 1.6x)
 */
export default function useProjectionZoom() {
  const compute = () => {
    const fs = typeof document !== 'undefined' && !!(document.fullscreenElement || document.webkitFullscreenElement);
    if (!fs) return 1;
    const w = (typeof window !== 'undefined' && window.innerWidth) || 1200;
    return Math.min(1.6, Math.max(1, w / 1200));
  };
  const [zoom, setZoom] = useState(compute);
  useEffect(() => {
    const on = () => setZoom(compute());
    document.addEventListener('fullscreenchange', on);
    document.addEventListener('webkitfullscreenchange', on);
    window.addEventListener('resize', on);
    return () => {
      document.removeEventListener('fullscreenchange', on);
      document.removeEventListener('webkitfullscreenchange', on);
      window.removeEventListener('resize', on);
    };
  }, []);
  return zoom;
}
